import clsx from 'clsx';
import React from 'react';

interface TextInputProps {
  label?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  helperText?: string;
  error?: string;
  placeholder?: string;
  disabled?: boolean;
  showTooltip?: boolean;
  required?: boolean;
  type?: string;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  helperText,
  error,
  placeholder,
  disabled,
  value,
  onChange,
  showTooltip,
  required = true,
  type = 'text',
}) => {
  return (
    <div className=" w-full flex-col justify-start items-start inline-flex">
      <div className=" w-full flex-col justify-start items-start gap-1 flex">
        <div className="self-stretch justify-start items-start gap-1 inline-flex">
          {label && (
            <div
              className={`text-navy-700 text-subtitle2a ${
                disabled && '!text-grey-300'
              }`}
            >
              {label}
            </div>
          )}
          {required && (
            <div
              className={`text-right text-red-400 text-subtitle2a ${
                disabled && '!text-grey-300'
              }`}
            >
              *
            </div>
          )}
        </div>

        <div className="self-stretch h-10 flex items-center gap-2 relative">
          <input
            className={clsx(
              'w-full h-full px-3 py-2 bg-white rounded border text-primary placeholder:text-navy-400 text-body2',
              'disabled:bg-grey-100 disabled:text-grey-300 disabled:placeholder-grey-300 disabled:border-grey-100',
              error
                ? 'border-red-400 outline-red-400 '
                : 'border-navy-200 outline-primary',
              'focus:outline-1'
            )}
            disabled={disabled}
            placeholder={placeholder}
            type={type}
            value={value}
            onChange={onChange}
          />
          <i
            className={clsx(
              'text-[20px] absolute right-3',
              // eslint-disable-next-line no-nested-ternary
              error
                ? 'ri-error-warning-fill text-red-400'
                : showTooltip
                ? 'ri-question-line text-navy-400'
                : '',
              disabled && '!text-grey-300'
            )}
          />
        </div>

        {helperText && (!error || disabled) && (
          <div
            className={`self-stretch pl-1 justify-start items-start gap-2.5 inline-flex text-navy-500 ${
              disabled && '!text-grey-300'
            }`}
          >
            <div className=" text-[12px] leading-none">{helperText}</div>
          </div>
        )}

        {!disabled && error && (
          <div className="self-stretch pl-1 justify-start items-start gap-2.5 inline-flex">
            <div className="text-red-400 text-[12px] leading-none">{error}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TextInput;
